module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('configuration.basic.title')))])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative"
    },
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        return _vm.drop($event)
      }
    }
  }, [_c('v-alert', {
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "success": "",
      "transition": "fade-transition",
      "value": _vm.saved
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('configuration.basic.saved')) + "\n    ")]), _vm._v(" "), _c('loadable', {
    attrs: {
      "loading": _vm.value === null
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t('configuration.basic.insertIdent')
    },
    model: {
      value: (_vm.value.insertIdent),
      callback: function($$v) {
        _vm.$set(_vm.value, "insertIdent", $$v)
      },
      expression: "value.insertIdent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('configuration.basic.maxAge'),
      "hint": _vm.$t('configuration.basic.maxAgeHint')
    },
    model: {
      value: (_vm.value.maxAge),
      callback: function($$v) {
        _vm.$set(_vm.value, "maxAge", $$v)
      },
      expression: "value.maxAge"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.compressionValues,
      "label": _vm.$t('configuration.basic.compression')
    },
    model: {
      value: (_vm.value.codecType),
      callback: function($$v) {
        _vm.$set(_vm.value, "codecType", $$v)
      },
      expression: "value.codecType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('configuration.basic.encrypt'),
      "items": _vm.encryptValues,
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.value.encrypt),
      callback: function($$v) {
        _vm.$set(_vm.value, "encrypt", $$v)
      },
      expression: "value.encrypt"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isByPassword) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('configuration.basic.password'),
      "type": "password"
    },
    model: {
      value: (_vm.value.password),
      callback: function($$v) {
        _vm.$set(_vm.value, "password", $$v)
      },
      expression: "value.password"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isByKey) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('configuration.basic.publicKey'),
      "multi-line": "",
      "rules": _vm.keyRules
    },
    model: {
      value: (_vm.value.encryptionKey),
      callback: function($$v) {
        _vm.$set(_vm.value, "encryptionKey", $$v)
      },
      expression: "value.encryptionKey"
    }
  }), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [(_vm.save) ? _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "success": "",
      "loading": _vm.isBusy
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('save')))])], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aae17f7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Configuration/Basic.vue
// module id = 1093
// module chunks = 1